import trimEnd from 'lodash-es/trimEnd';

export interface BaseWidgetConfigData {
  /**
   * Base url of the AG API that the AG Bar component will fetch/save it's data
   *
   * EG: 'https://qa-agapi-rel.redmz.mrisoftware.com'
   */
  baseApiUrl: string;
  cdnUrl: string;
}

const defaults: BaseWidgetConfigData = {
  baseApiUrl: '',
  cdnUrl: ''
};

// eslint-disable-next-line @typescript-eslint/no-empty-object-type, @typescript-eslint/no-empty-interface
export interface BaseWidgetConfig extends BaseWidgetConfigData {}

export abstract class BaseWidgetConfig {
  get apiDomain() {
    return this.baseApiUrl ? new URL(this.baseApiUrl).hostname : 'localhost';
  }

  // private get IsDeveloperServer() {
  //   return this.apiDomain.includes('local');
  // }

  constructor(json?: BaseWidgetConfigData) {
    json = json ?? defaults;
    const baseApiUrl = trimEnd(json.baseApiUrl, '/').trim();
    const cdnUrl = trimEnd(json.cdnUrl);
    Object.assign(this, defaults, json, { baseApiUrl, cdnUrl });
  }
}
